import { RootState } from 'editor/src/store/index';

import getSpread from './getSpread';

const hasUsedImagesInSpread = (state: RootState, spreadIndex: number) =>
  getSpread(state, spreadIndex)?.pages[0].groups.media?.some((el) => el.type === 'image' && el.imageId) || false;

export default hasUsedImagesInSpread;
